import { createContext } from 'react'

import { MysqlUsers } from '../graphqlTypes'

type MysqlUsersField = keyof MysqlUsers

type ReviewFilter = {
  categories: number[]
  column: MysqlUsersField
}

type UserAttributes = {
  categories: number[]
  columns: MysqlUsersField[]
}

type Context = {
  reviewFilters: ReviewFilter[]
  userAttributes: UserAttributes[]
}

const context: Context = {
  reviewFilters: [
    {
      categories: [2, 3, 4, 5],
      column: 'milk'
    },
    {
      categories: [8, 9, 12],
      column: 'youngest_child_weight'
    },
    {
      categories: [17],
      column: 'mother_birthday'
    },
    {
      categories: [22, 23],
      column: 'transport'
    },
    {
      categories: [25],
      column: 'car_model'
    },
    {
      categories: [29, 37],
      column: 'floor_plan'
    }
  ],
  userAttributes: [
    {
      categories: [2, 3, 4, 5],
      columns: ['support_member', 'milk']
    },
    {
      categories: [8, 9, 10, 12, 14, 15],
      columns: ['youngest_child_height', 'youngest_child_weight']
    },
    {
      categories: [13],
      columns: ['prefecture_id', 'residential_area', 'youngest_child_height', 'youngest_child_weight']
    },
    {
      categories: [22, 23],
      columns: [
        'prefecture_id',
        'residential_area',
        'building_type',
        'floor_plan',
        'transport',
        'step_existence',
        'support_member',
        'youngest_child_height',
        'youngest_child_weight'
      ]
    },
    {
      categories: [24],
      columns: [
        'prefecture_id',
        'residential_area',
        'transport',
        'support_member',
        'mother_height',
        'mother_weight',
        'youngest_child_height',
        'youngest_child_weight'
      ]
    },
    {
      categories: [25],
      columns: [
        'prefecture_id',
        'residential_area',
        'transport',
        'car_model',
        'support_member',
        'youngest_child_height',
        'youngest_child_weight'
      ]
    },
    {
      categories: [29, 30],
      columns: ['building_type', 'floor_plan', 'youngest_child_height', 'youngest_child_weight']
    },
    {
      categories: [31],
      columns: ['building_type', 'youngest_child_height', 'youngest_child_weight']
    },
    {
      categories: [37],
      columns: ['prefecture_id', 'residential_area', 'building_type', 'floor_plan', 'noise_care']
    },
    {
      categories: [39],
      columns: ['noise_care']
    },
    {
      categories: [41],
      columns: ['prefecture_id', 'residential_area', 'building_type']
    },
    {
      categories: [43],
      columns: ['prefecture_id', 'residential_area']
    }
  ]
}

export default createContext(context)
